import type { SalaryBand } from '../../services/salaryBandsApi';

const COLUMNS: Array<[string, keyof SalaryBand]> = [
  ['Department', 'department'],
  ['Unit', 'unit'],
  ['Career path', 'careerPath'],
  ['Title', 'title'],
  ['Level', 'level'],
  ['Degree', 'degree'],
  ['Min', 'min'],
  ['Average', 'average'],
  ['Max', 'max'],
  ['OTE Min', 'oteMin'],
  ['OTE Average', 'oteAverage'],
  ['OTE Max', 'oteMax'],
  ['Lower third', 'lowerThird'],
  ['Middle third', 'middleThird'],
  ['Upper third', 'upperThird'],
  ['Initial Grant Value', 'grantValueVsop'],
  ['VSOP', 'vsop'],
];

function csvCell(value: unknown) {
  const raw = value == null ? '' : String(value);
  const safe = /^[\t\r\n=+\-@]/.test(raw) ? `'${raw}` : raw;
  return `"${safe.replaceAll('"', '""')}"`;
}

export function salaryBandsToCsv(bands: SalaryBand[]) {
  const header = COLUMNS.map(([label]) => csvCell(label)).join(',');
  const rows = bands.map((band) => COLUMNS.map(([, key]) => csvCell(band[key])).join(','));
  return [header, ...rows].join('\r\n');
}

export function downloadSalaryBandsCsv(bands: SalaryBand[], filename = 'salary-bands.csv') {
  const blob = new Blob([`\uFEFF${salaryBandsToCsv(bands)}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}
